import type { AsyncHasMany } from '@ember-data/model';
import { hasMany } from '@ember-data/model';
import ProductModelCommon from 'common/models/product';
import type UserModel from './user';

export default class ProductModel extends ProductModelCommon {
  @hasMany('user') declare favorites: AsyncHasMany<UserModel>;
}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    product: ProductModelCommon;
  }
}
